import { type JSX, type ReactNode } from 'react'

import { Link as BaseLink } from 'base-ui'

import { useGlobalConfigContext } from '../../../../../global-config'
import { urlResolverGetMediServiceRxLandingPageSecondQuestionPartnerLink } from '../../../../../url-handling'

export const RxLpChHowToLink = (text: ReactNode[]): JSX.Element => {
  const config = useGlobalConfigContext()

  return (
    <BaseLink
      href={urlResolverGetMediServiceRxLandingPageSecondQuestionPartnerLink(
        config,
      )}
      target="_blank"
    >
      {text}
    </BaseLink>
  )
}
